import setFilters from 'store/reducer-utils/setFilters'
import {
  RESET_PAYMENT_PROFILES_DATA,
  SET_PAYMENT_PROFILE_DATA,
  SET_PAYMENT_PROFILES_FILTER,
  SET_PAYMENT_PROFILES_DATA,
  DROP_PAYMENT_PROFILES_DATA,
} from 'modules/Finance/PaymentProfiles/store/types'

const initialState = {
  filters: null,
}

const setPaymentProfilesData = (state, { payload }) => ({
  ...state,
  paymentProfiles: { ...(state?.paymentProfiles ?? {}), ...payload },
})

const setPaymentProfileData = (state, { payload }) => ({
  ...state,
  paymentProfile: { ...(state?.paymentProfile ?? {}), ...payload },
})

const setPaymentProfilesFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const resetPaymentProfilesData = () => ({
  ...initialState,
})

const dropPaymentProfilesData = (state) => ({
  ...state,
  paymentProfiles: { ...(state.paymentProfiles ?? {}), data: [] },
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAYMENT_PROFILES_DATA:
      return setPaymentProfilesData(state, action)
    case SET_PAYMENT_PROFILE_DATA:
      return setPaymentProfileData(state, action)
    case SET_PAYMENT_PROFILES_FILTER:
      return setPaymentProfilesFilter(state, action)
    case RESET_PAYMENT_PROFILES_DATA:
      return resetPaymentProfilesData(state, action)
    case DROP_PAYMENT_PROFILES_DATA:
      return dropPaymentProfilesData(state, action)

    default:
      return state
  }
}

export default reducer
